const dropdownHandler = {
	data: function () {
		return {
			show: [],
		}
	},
	methods: {
		toggleClasses(classes, index){
			return classes += this.show.includes(index) ? ' show' : '';
		},
		showToggle : function(uid) {
			this.show.includes(uid) ? this.show.splice(this.show.indexOf(uid), 1) : this.show.push(uid);
			let el = document.getElementById(uid);
			if(!el){
				return
			}
			el.classList.contains('show') ? el.classList.remove('show') : el.classList.add('show');
		},
	}
}

export default dropdownHandler